import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { FallbackService } from '../services/fallback.service';

@Injectable({
  providedIn: 'root',
})
export class FallbackGuard {
  /**
   * constructor
   *
   */
  constructor(
    private router: Router,
    private fallbackService: FallbackService,
  ) {}

  /**
   * canActivate
   *
   */
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (this.fallbackService.isActivate) {
      return true;
    }

    this.router.navigate(['/']).catch();

    return false;
  }
}
